import { proxy } from "valtio";
import { ModalState } from "../types";

export const ModalStore = proxy<ModalState>({
  appVersionUpdateModalVisible: false,
  turnOnNotificationModalVisible: false,
  lowCreditModalVisible: false,
  appRatingModalVisible: false,
  trackerWelcomeModalVisible: false,
});

// APP 升级弹窗调用，关闭其他弹窗
export const closeOtherModals = () => {
  ModalStore.turnOnNotificationModalVisible = false;
  ModalStore.lowCreditModalVisible = false;
  ModalStore.appRatingModalVisible = false;
  ModalStore.trackerWelcomeModalVisible = false;
};
